import React, { PropsWithChildren, useEffect } from 'react';
import {useAsync} from "react-async-hook";
import { useParams } from 'react-router-dom';
import {
  Menu,
  MenuItem,
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import icon303a from '../../assets/images/active_icon_ROOM_TaskBoard_Re3_03.png';
import icon305a from '../../assets/images/active_icon_ROOM_TaskBoard_Re3_05.png';
import icon307a from '../../assets/images/active_icon_ROOM_TaskBoard_Re3_07.png';
import icon303d from '../../assets/images/disabled_icon_ROOM_TaskBoard_Re3_03.png';
import icon305d from '../../assets/images/disabled_icon_ROOM_TaskBoard_Re3_05.png';
import icon307d from '../../assets/images/disabled_icon_ROOM_TaskBoard_Re3_07.png';
import icon442 from '../../assets/images/ROOM_TaskBoard_Re4_42.png';
import icon410 from '../../assets/images/ROOM_TaskBoard_Re4_10.png';
import icon416 from '../../assets/images/ROOM_TaskBoard_Re4_16.png';
import logo from '../../assets/images/room_logo.png';
import { useTaskCollapsed } from '../../hooks/useTaskCollapsed';
import { useFileSearch } from '../../hooks/useFileSearch';
import useAppRouter from '../../hooks/useAppRouter';
import {useAuth} from "../../hooks/useAuth";
import { RouteName, routes } from '../../routes';
import {PasswordEditModal} from "../pages/admin/Account/PasswordEditModal";
import {config} from "../../libs/config/config";


interface TaskBoardParams {
  roomId: string;
}

const tabs = [
  {
    name: 'ボード',
    activeIcon: icon303a,
    icon: icon303d,
    routeName: 'taskList',
  },
  {
    name: 'ファイル',
    activeIcon: icon305a,
    icon: icon305d,
    routeName: 'roomAttachFile',
  },
  {
    name: '参加者',
    activeIcon: icon307a,
    icon: icon307d,
    routeName: 'roomMember',
  },
];

export const TaskBoardLayout: React.FC = ({
                                          children,
                                        }: PropsWithChildren<any>) => {
  const { roomId } = useParams<TaskBoardParams>();
  const { goto, gotoTopByUser } = useAppRouter();
  const { logout, state: { currentUser } } = useAuth();
  if(currentUser?.accessRoomIds.every( id => id !== Number(roomId))) {
    goto('forbiddenError');
  }

  const pathName = window.location.pathname;
  const [tabIndex, setTabIndex] = React.useState<number>(1);
  const { collapsed, handleCollapsed } = useTaskCollapsed();
  const {
    keyword,
    handleChange,
    handleSubmit: handleSearchSubmit,
  } = useFileSearch();

  const [ showPasswordEditModal, setShowPasswordEditModal ] = React.useState<boolean>(false);

  useAsync(
    async () => {
      document.title = config.app.room.name;
    },
    []);

  useEffect(() => {
    setTabIndex(
      tabs.findIndex(
        (t) => routes[t.routeName as keyof typeof routes].path.replace(":roomId",roomId) === pathName
      ) + 1
    );
    // eslint-disable-next-line
  }, [pathName]);

  const handleSelect = (index: number) => {
    goto(tabs[index - 1].routeName as RouteName, undefined, { roomId });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSearchSubmit();
  };

  return (
    <>
      {showPasswordEditModal && (
        <PasswordEditModal
          {...{
            setShowModal: setShowPasswordEditModal,
            onSaved: async () => {setShowPasswordEditModal(false)},
          }}
        />
      )}
      <header>
        <Tabs
          onSelect={(index) => handleSelect(index)}
          selectedIndex={tabIndex}
        >
          <TabList>
            <Tab disabled>
              <button
                type="button"
                className="focus:outline-none"
                onClick={() => gotoTopByUser()}
              >
                <div className="flex flex-col w-24">
                  <img src={logo} alt="ROOM" className="object-contain" />
                  <span className="text-primary text-sm font-semibold truncate">
                    { currentUser?.roomName }
                  </span>
                </div>
              </button>
            </Tab>
            {tabs.map((t, index) => (
              <Tab key={t.name}>
                <img
                  src={tabIndex === index + 1 ? t.activeIcon : t.icon}
                  alt="icon"
                />
                <div className="ml-4">{t.name}</div>
              </Tab>
            ))}
          </TabList>
          <TabPanel />
          <TabPanel />
          <TabPanel />
          <TabPanel />
          <div className="flex items-center">
            {pathName === routes.taskList.path.replace(":roomId",roomId) && (
              <button
                onClick={handleCollapsed}
                type="button"
                className="flex items-center text-gray-300 text-sm font-semibold relative -bottom-1 h-full px-8 outline-none focus:outline-none"
              >
                <img src={icon410} alt="icon" />
                <div className="ml-4">
                  {collapsed ? '全て開く' : '全てたたむ'}
                </div>
              </button>
            )}
            {pathName === routes.roomAttachFile.path.replace(":roomId",roomId) && (
              <form onSubmit={handleSubmit}>
                <div className="flex items-center text-gray-300 text-sm font-semibold relative -bottom-1 h-full">
                  <div className="w-64 flex items-center px-4 py-1 border border-gray-300 rounded-full text-xs text-black">
                    <input
                      type="text"
                      defaultValue={keyword}
                      onChange={(event) => handleChange(event.target.value)}
                      className="flex-grow outline-none focus:outline-none"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="outline-none focus:outline-none"
                    >
                      <img src={icon416} alt="icon" className="flex-none w-4" />
                    </button>
                  </div>
                </div>
              </form>
            )}
            <div className="flex items-center text-gray-300 text-sm font-semibold relative -bottom-1 h-full px-8">
              <div className="ml-4">
                <Menu
                  position="anchor"
                  align="end"
                  /* eslint-disable-next-line react/jsx-boolean-value */
                  arrow={true}
                  menuButton={
                    <button
                      type="button"
                      className="flex items-center justify-center w-full rounded-md  px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-50 focus:outline-none"
                    >
                      <img src={icon442} alt="icon" />
                    </button>
                  }
                >
                  <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
                    <button
                      className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                      type="button"
                      onClick={() => {
                        setShowPasswordEditModal(true);
                      }}
                    >
                      パスワード変更
                    </button>
                  </MenuItem>
                  <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
                    <button
                      className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                      type="button"
                      onClick={logout}
                    >
                      ログアウト
                    </button>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </Tabs>
      </header>
      <main>{children}</main>
    </>
  );
};